import { FileUploader } from "@carbon/react";
import { ArrowUp } from "@carbon/icons-react";

import { fileUploaderConstants } from "../../constants";

export const View = ({
  allowMultiple = false,
  accept = [],
  label = "",
  name,
  onChange = (e) => {},

  ...rest
}) => {
  return (
    <div className="file-upload--container">
      <FileUploader
        {...rest}
        accept={
          accept.length ? accept : fileUploaderConstants.AllowedImageFileTypes
        }
        innerRef={{
          current: "[Circular]",
        }}
        labelText={
          <div className="flex-container justify-content--center align-items--center">
            <ArrowUp />
            {label}
            {/* <p>Drag image here</p> */}
          </div>
        }
        filenameStatus="complete"
        multiple={allowMultiple}
        name={name}
        onAddFiles={function noRefCheck() {}}
        onChange={onChange} // {function noRefCheck() {}}
        role=""
      />
      {/* <FileUploader
        accept={[".jpg", ".png"]}
        buttonKind="primary"
        className="switchapp-themed"
        buttonLabel="Add files"
        filenameStatus="edit"
        iconDescription="Clear file"
        labelDescription="only .jpg files at 500mb or less"
        labelTitle="Upload"
      /> */}
    </div>
  );
};
